// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__-Xlnc","Logo":"Loading_Logo__KGKfD"};